import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { setItemsFlagStateFromTable } from './setItemsFlagState';
import setConversationsFlagState from './setConversationsFlagState';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
export default function setMailListRowsFlagState(rowKeys, tableViewId, flagStatusToApply) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            setConversationsFlagState(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
            break;
        case 1 /* Message */:
            setItemsFlagStateFromTable(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
            break;
    }
}
//# sourceMappingURL=setMailListRowsFlagState.js.map